// Safely extract a human-readable error message from an axios error.
// Backend 402 responses now use structured detail objects
// ({paywall_action, message}); passing them directly to a React toast crashes
// with "Objects are not valid as a React child". This helper flattens them.
export function errMsg(err, fallback = "Erreur") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object") {
    return detail.message || detail.msg || detail.detail || fallback;
  }
  return err?.message || fallback;
}
